import React from 'react';
import { Link } from 'react-router-dom';
import { FiTruck, FiClock, FiShield, FiGlobe } from 'react-icons/fi';

export default function Shipping() {
  return (
    <div className="min-h-screen bg-black text-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'serif' }}>
          Shipping Information
        </h1>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Fast, reliable shipping to get your dress to you quickly and safely.
          </p>
        </div>

        {/* Product-Specific Shipping */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="bg-gray-900 rounded-2xl p-8 text-center">
            <div className="w-16 h-16 bg-pink-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <FiTruck className="text-pink-500" size={32} />
            </div>
            <h3 className="text-xl font-bold text-white mb-4">Jewelry & Shoes</h3>
            <p className="text-gray-400 mb-4">Available only in the USA</p>
            <p className="text-pink-500 font-bold text-lg">Delivered within 3-5 Days</p>
            <p className="text-gray-400 text-sm mt-2">FREE shipping on orders over $50</p>
          </div>

          <div className="bg-gray-900 rounded-2xl p-8 text-center">
            <div className="w-16 h-16 bg-pink-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <FiGlobe className="text-pink-500" size={32} />
            </div>
            <h3 className="text-xl font-bold text-white mb-4">Custom Made Dresses</h3>
            <p className="text-gray-400 mb-4">International Shipping Available</p>
            <p className="text-pink-500 font-bold text-lg">Processing: 7-14 Days</p>
            <p className="text-pink-500 font-bold text-lg">Delivery: 5-14 Days</p>
            <p className="text-gray-400 text-sm mt-2">FREE shipping on orders over $50</p>
          </div>
        </div>

        {/* Quick Shipping Option */}
        <div className="bg-gradient-to-r from-pink-500/20 to-purple-500/20 rounded-2xl p-8 mb-16 text-center">
          <div className="w-16 h-16 bg-pink-500/30 rounded-full flex items-center justify-center mx-auto mb-6">
            <FiClock className="text-pink-500" size={32} />
          </div>
          <h3 className="text-2xl font-bold text-white mb-4">Need Quick Shipping?</h3>
          <p className="text-gray-300 mb-6 text-lg">
            For urgent orders or special delivery requirements, please contact us directly. 
            We'll work with you to find the fastest shipping solution.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-3 bg-pink-500 text-white font-semibold rounded-lg hover:bg-pink-600 transition-colors"
          >
            Contact Us for Quick Shipping
          </Link>
        </div>

        {/* Shipping Process */}
        <div className="bg-gray-900 rounded-2xl p-8 mb-16">
          <h2 className="text-2xl font-bold text-white mb-8 text-center">How It Works</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">1</span>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Order Processing</h3>
              <p className="text-gray-400 text-sm">Orders are processed within 1-2 business days</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">2</span>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Packaging</h3>
              <p className="text-gray-400 text-sm">Items are carefully packaged for safe delivery</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">3</span>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Shipping</h3>
              <p className="text-gray-400 text-sm">Your order ships with tracking information</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">4</span>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Delivery</h3>
              <p className="text-gray-400 text-sm">Your order arrives safely at your doorstep</p>
            </div>
          </div>
        </div>

        {/* Important Information */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="bg-gray-900 rounded-2xl p-8">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <FiShield className="text-pink-500 mt-1" size={24} />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">Shipping Protection</h3>
                <p className="text-gray-400">
                  All orders are fully insured during transit. If your package is lost or damaged, 
                  we'll replace it at no cost to you.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-900 rounded-2xl p-8">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <FiTruck className="text-pink-500 mt-1" size={24} />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">Delivery Areas</h3>
                <p className="text-gray-400">
                  We ship to all 50 US states, Canada, and internationally. 
                  International shipping rates are calculated at checkout.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="text-center">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Need Help with Shipping?</h2>
            <p className="text-gray-400 mb-6">
              Have questions about your order or shipping options? We're here to help!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center px-6 py-3 bg-pink-500 text-white font-semibold rounded-lg hover:bg-pink-600 transition-colors"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
